export default __webpack_public_path__ + "3d893a48a6b776ac6b18f1b0d30df585.png";